module.exports = __webpack_public_path__ + "static/gallery-img-23-44ef71b3d473fbc89d4f6d8ed16516ba.jpg";